export default __webpack_public_path__ + "static/media/candidates_icon.3420dbd0.svg";